const calculatePercentage = (actualValue, maxValue) => {
  if (maxValue === 0) {
    throw new Error('O valor máximo não pode ser zero.')
  }
  let percentage = (actualValue / maxValue) * 100
  return Number(percentage.toFixed(2))
}

export default calculatePercentage
